import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMapMarkerAlt, 
  faPhone, 
  faEnvelope, 
  faClock,
  faPaperPlane,
  faCheckCircle,
  faUser,
  faBuilding,
  faGlobe
} from '@fortawesome/free-solid-svg-icons';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
const[loading,setLoading]= useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Here you would typically send the form data to your backend
  //   console.log('Form submitted:', formData);
  //   setIsSubmitted(true);
    
  //   // Reset form after 3 seconds
  //   setTimeout(() => {
  //     setIsSubmitted(false);
  //     setFormData({
  //       name: '',
  //       email: '',
  //       phone: '',
  //       company: '',
  //       service: '',
  //       message: ''
  //     });
  //   }, 3000);
  // };
const handleSubmit = async (event) => {
  setLoading(true);
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "05aa0895-6627-433c-83d8-566602f3a414");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: json
    }).then((res) => res.json());

    if (res.success) {
      console.log("Success", res);
    alert("message sent succesfully");
    isSubmitted(true)
    }
    setLoading(false);

  };


  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-primary-green to-secondary-blue text-white py-20 lg:py-32 text-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src="/images/contact us .png" 
            alt="Contact Us Hero Background" 
            className="w-full h-full object-cover opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-green/40 to-secondary-blue/40"></div>
        </div>
        
        {/* Content */}
        <div className="container relative z-10">
          <div className="max-w-4xl mx-auto space-y-6">
            <h1 className="text-4xl md:text-6xl font-bold animate-fade-in text-white drop-shadow-2xl shadow-black">Get In Touch</h1>
            <p className="text-xl md:text-2xl animate-fade-in text-white drop-shadow-xl shadow-black font-semibold" style={{animationDelay: '0.2s'}}>
              Ready to start your renewable energy journey? Contact us today for a free consultation
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="section bg-white">
        <div className="container">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-dark mb-4">Send Us a Message</h2>
                <p className="text-lg text-gray">Fill out the form below and we'll get back to you within 24 hours</p>
              </div>
              
              {isSubmitted ? (
                <div className="bg-gray-light p-12 rounded-3xl text-center">
                  <FontAwesomeIcon icon={faCheckCircle} className="text-6xl text-primary-green mb-6" />
                  <h3 className="text-3xl font-bold text-dark mb-4">Thank You!</h3>
                  <p className="text-lg text-gray">Your message has been sent successfully. We'll get back to you soon!</p>
                </div>
              ) : (
                <form className="space-y-6" onSubmit={handleSubmit}>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label htmlFor="name" className="flex items-center gap-2 font-semibold text-dark">
                        <FontAwesomeIcon icon={faUser} className="text-primary-green" />
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter your full name"
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-primary-green focus:outline-none focus:ring-4 focus:ring-primary-green/10 transition-all duration-300"
                      />
                    </div>
                    <div className="space-y-2">
                      <label htmlFor="email" className="flex items-center gap-2 font-semibold text-dark">
                        <FontAwesomeIcon icon={faEnvelope} className="text-primary-green" />
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="Enter your email address"
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-primary-green focus:outline-none focus:ring-4 focus:ring-primary-green/10 transition-all duration-300"
                      />
                    </div>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label htmlFor="phone" className="flex items-center gap-2 font-semibold text-dark">
                        <FontAwesomeIcon icon={faPhone} className="text-primary-green" />
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Enter your phone number"
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-primary-green focus:outline-none focus:ring-4 focus:ring-primary-green/10 transition-all duration-300"
                      />
                    </div>
                    <div className="space-y-2">
                      <label htmlFor="company" className="flex items-center gap-2 font-semibold text-dark">
                        <FontAwesomeIcon icon={faBuilding} className="text-primary-green" />
                        Company Name
                      </label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        placeholder="Enter your company name"
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-primary-green focus:outline-none focus:ring-4 focus:ring-primary-green/10 transition-all duration-300"
                      />
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <label htmlFor="service" className="flex items-center gap-2 font-semibold text-dark">
                      <FontAwesomeIcon icon={faGlobe} className="text-primary-green" />
                      Service of Interest
                    </label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-primary-green focus:outline-none focus:ring-4 focus:ring-primary-green/10 transition-all duration-300"
                    >
                      <option value="">Select a service</option>
                      <option value="solar">Solar Power Solutions</option>
                      <option value="wind">Wind Energy Systems</option>
                      <option value="hydro">Hydroelectric Power</option>
                      <option value="storage">Energy Storage Solutions</option>
                      <option value="consulting">Consulting & Planning</option>
                      <option value="maintenance">Maintenance & Repair</option>
                    </select>
                  </div>
                  
                  <div className="space-y-2">
                    <label htmlFor="message" className="flex items-center gap-2 font-semibold text-dark">
                      <FontAwesomeIcon icon={faPaperPlane} className="text-primary-green" />
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder="Tell us about your project or inquiry..."
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-primary-green focus:outline-none focus:ring-4 focus:ring-primary-green/10 transition-all duration-300 resize-vertical"
                    ></textarea>
                  </div>
                  
                  <button type="submit" className="w-full btn btn-primary text-lg py-4 group">
                   {loading?"Sending Message":"Send Message"} 
                    <FontAwesomeIcon icon={faPaperPlane} className="group-hover:translate-x-1 transition-transform" />
                  </button>
                </form>
              )}
            </div>

            {/* Contact Information */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-dark mb-4">Contact Information</h2>
                <p className="text-lg text-gray">Get in touch with us through any of these channels</p>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-6 p-6 bg-gray-light rounded-2xl hover:-translate-y-1 transition-all duration-300 hover:shadow-lg">
                  <div className="w-12 h-12 bg-gradient-to-r from-primary-green to-primary-green-light rounded-xl flex items-center justify-center flex-shrink-0">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="text-white text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-dark mb-2">Office Address</h4>
                    <p className="text-gray leading-relaxed">
                    Plot no -109, Old Ag Colony, Unit 4,
                      <br />
                      Madhusudan Nagar, Bhubaneswar,<br />
                      Odisha, India 400001<br />
                      India
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-6 p-6 bg-gray-light rounded-2xl hover:-translate-y-1 transition-all duration-300 hover:shadow-lg">
                  <div className="w-12 h-12 bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-xl flex items-center justify-center flex-shrink-0">
                    <FontAwesomeIcon icon={faPhone} className="text-white text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-dark mb-2">Phone Numbers</h4>
                    <p className="text-gray leading-relaxed">
                      +91 80932 37123 <br />
              
                     
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-6 p-6 bg-gray-light rounded-2xl hover:-translate-y-1 transition-all duration-300 hover:shadow-lg">
                  <div className="w-12 h-12 bg-gradient-to-r from-primary-green to-secondary-blue rounded-xl flex items-center justify-center flex-shrink-0">
                    <FontAwesomeIcon icon={faEnvelope} className="text-white text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-dark mb-2">Email Addresses</h4>
                    <p className="text-gray leading-relaxed">
                    corenovarenewable@gmail.com<br />
                      
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-6 p-6 bg-gray-light rounded-2xl hover:-translate-y-1 transition-all duration-300 hover:shadow-lg">
                  <div className="w-12 h-12 bg-gradient-to-r from-primary-green to-primary-green-light rounded-xl flex items-center justify-center flex-shrink-0">
                    <FontAwesomeIcon icon={faClock} className="text-white text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-dark mb-2">Business Hours</h4>
                    <p className="text-gray leading-relaxed">
                      Monday - Friday: 9:30 AM - 6:30 PM<br />
                      Saturday: 9:30 AM - 6:30 PM<br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gradient-to-r from-primary-green to-secondary-blue text-white p-8 rounded-2xl text-center">
                <h3 className="text-2xl font-bold mb-4">Emergency Support</h3>
                <p className="mb-6 opacity-90">For urgent technical support or emergency services, call our 24/7 hotline:</p>
                <div className="flex items-center justify-center gap-3 text-2xl font-bold">
                  <FontAwesomeIcon icon={faPhone} />
                  <span>+91 80932 37123</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="section bg-gray-light">
        <div className="container">
          <div className="section-title">
            <h2>Find Us</h2>
            <p>Visit our office or explore our service areas</p>
          </div>
          <div className="bg-white rounded-3xl overflow-hidden shadow-2xl">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11487.919780990083!2d85.8350311397493!3d20.284486360855393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19090069a9e991%3A0x79f9a2326986a08b!2sCorenova%20Agency%20pvt%20ltd!5e1!3m2!1sen!2sin!4v1754720557866!5m2!1sen!2sin" 
              width="100%" 
              height="450" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Corenova Agency Pvt Ltd Location"
              className="w-full"
            ></iframe>
          </div>
        </div>
      </section>

  {/* FAQ Section */}
<section className="section bg-white">
  <div className="container">
    <div className="section-title text-center mb-10">
      <h2 className="text-3xl font-bold">Frequently Asked Questions</h2>
      <p className="text-gray-600">Quick answers to common questions about our Renewable Energy Services in Odisha</p>
    </div>

    <div className="space-y-4">
      {[
        {
          q: "What makes solar power the best choice for businesses in Odisha?",
          a: "Choosing a solar power solution for your business is a strategic investment that offers a rapid return on investment and long-term savings. With rising commercial electricity tariffs, a commercial solar installation in Odisha can significantly reduce your operational costs. Furthermore, adopting solar energy boosts your brand's reputation as a leader in sustainability and a contributor to the state's green energy goals."
        },
        {
          q: "Can I install a solar system for my home in Bhubaneswar?",
          a: "Absolutely. We specialize in providing residential solar panels in Bhubaneswar. Our team will conduct a thorough site assessment to design a system that fits your home perfectly, helping you to cut down on electricity bills and enjoy clean, uninterrupted power. We handle the entire process from consultation to final solar panel installation in Odisha."
        },
        {
          q: "How do I know I'm getting a quality solar system?",
          a: "Quality is our top priority. As one of the best solar panel dealers in Bhubaneswar, we only work with high-quality, government-certified solar panels and inverters. Our expertise in Renewable Energy Services ensures that every component is reliable, durable, and designed to perform optimally for over 25 years."
        },
        {
          q: "What are the benefits of a Wind Power solution in Odisha?",
          a: "Wind energy is a powerful and reliable component of our Renewable Energy Services. Wind turbines are ideal for large-scale energy generation in windy coastal and inland areas of Odisha. A Wind Power solution in Odisha can provide a consistent source of clean electricity, reducing dependence on fossil fuels and contributing to the state's renewable energy goals."
        },
        {
          q: "Does Corenova also work with hydroelectric power?",
          a: "Yes, we are committed to providing diverse Renewable Energy Services. Our portfolio includes Hydroelectric Power in Odisha, which harnesses the energy of flowing water to generate electricity. This is a reliable and clean source of energy that complements our solar and wind solutions, especially for larger-scale projects and rural electrification."
        },
        {
          q: "What is the process of getting a solar system installed?",
          a: "Our process for a Solar installation in Odisha is simple and hassle-free. It begins with a consultation and a site survey to understand your energy needs. Next, we design a custom solar system and provide you with a detailed quote. Once approved, we handle the entire installation process and coordinate with the local grid company for net metering, ensuring a seamless experience."
        },
        {
          q: "What is the estimated cost of solar installation in Odisha?",
          a: "The cost of solar installation in Odisha varies, but it is a highly profitable long-term investment. The return on investment for a solar rooftop project is typically achieved within 3-5 years, after which you will enjoy free electricity for decades. We provide a transparent breakdown of all costs and help you access available subsidies to minimize your initial investment."
        },
        {
          q: "What makes Corenova the best solar company in Odisha?",
          a: "Corenova stands out as the best solar company in Odisha due to our commitment to quality, customer service, and expertise in diverse solar power solutions. We are a trusted partner in the state's renewable energy growth, with a proven track record of successful installations for both residential and commercial clients. We ensure every project is designed for maximum efficiency and long-term reliability."
        },
        {
          q: "Can I install solar panels on my office building or factory?",
          a: "Absolutely. We offer tailored commercial solar installation in Odisha services for all types of businesses, including factories, offices, and educational institutions. Installing a commercial solar system is a smart business move that provides significant savings on electricity bills, tax benefits, and a positive brand image."
        },
        {
          q: "Does Corenova offer solutions besides solar?",
          a: "Yes, our expertise extends beyond solar. We are a leading provider of comprehensive Renewable Energy Services, including Hydroelectric power in Odisha and Wind Energy solutions. We are equipped to meet a wide range of energy needs with clean, sustainable, and profitable solutions across different sectors."
        }
      ].map((faq, idx) => (
        <details
          key={idx}
          className="group border rounded-xl p-5 bg-gray-50 hover:shadow-md transition-all"
        >
          <summary className="flex justify-between items-center cursor-pointer font-semibold text-lg text-dark">
            {faq.q}
            <span className="ml-2 transition-transform group-open:rotate-180">▼</span>
          </summary>
          <p className="mt-3 text-gray-600 leading-relaxed">{faq.a}</p>
        </details>
      ))}
    </div>
  </div>
</section>

    </div>
  );
};

export default Contact; 